import { getOptimizelyClient } from './Provider';

const useOptlyEvent = () => {
  const client = getOptimizelyClient();

  if (!client?.user?.id) {
    return () => {};
  }

  return (event: string, eventTags = {}) => {
    if (!event) throw TypeError('no event declared');
    client.track(event, eventTags);
  };
};

export { useOptlyEvent };
